/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as $ from "jquery";
import {UiComponent} from "../UiComponent";
import {doOnceOnClickOutsideElement, positionDropDown} from "../Common";
import {DEFAULT_TEMPLATES} from "trivial-components";
import {UiComponentConfig} from "../../generated/UiComponentConfig";

export class UiDropDown {
	private $dropDown: JQuery;
	private $contentContainer: JQuery;
	private _isOpen = false;
	private $currentOriginElement: JQuery | Element;

	private currentAlignmentProperties: { width: number; viewPortPadding: number; minHeightBeforeFlipping: number };
	public onClose: (contentComponent?: UiComponent<UiComponentConfig>) => void;
	public onComponentRemoved: (contentComponent: UiComponent<UiComponentConfig>) => void;
	private contentComponent: UiComponent<UiComponentConfig>;

	constructor(content?: UiComponent<UiComponentConfig>) {
		this.$dropDown = $(`<div class="UiDropDown teamapps-blurredBackgroundImage">
                <div class="background-color-div">
              </div>`).appendTo('body');
		this.$contentContainer = this.$dropDown.find('.background-color-div');

		if (content) {
			this.setContent(content);
		}
	}

	setContent(component: UiComponent<UiComponentConfig>) {
		this.$contentContainer.empty();
		if (this.contentComponent) {
			this.onComponentRemoved(this.contentComponent);
		}

		this.contentComponent = component;

		if (component != null) {
			this.$contentContainer.append(component.getMainDomElement())
		}

		if (this._isOpen) {
			// this.repositionDropDown(); TODO!!!!
		}
	}

	open($originElement: JQuery | Element, {
		width = 250,
		viewPortPadding = 10,
		minHeightBeforeFlipping = 200
	}) {
		if (!this.contentComponent) {
			this.$contentContainer.append(DEFAULT_TEMPLATES.defaultSpinnerTemplate);
		}

		this.$currentOriginElement = $originElement;
		this.currentAlignmentProperties = {width, viewPortPadding, minHeightBeforeFlipping};
		this.$dropDown.width(width + "px");

		if (!this._isOpen) {
			this._isOpen = true;
			this.$dropDown.addClass('open');
			doOnceOnClickOutsideElement(this.$dropDown, () => {
				if (this._isOpen) {
					this.close();
				}
			});
		}

		this.repositionDropDown();
		this.contentComponent && this.contentComponent.reLayout();
	}

	repositionDropDown() {
		positionDropDown($(this.$currentOriginElement), this.$dropDown, this.currentAlignmentProperties);
	}

	close() {
		if (this._isOpen) {
			this.$dropDown.removeClass('open');
			this.onClose && this.onClose();
		}
		this._isOpen = false;
		this.$currentOriginElement = null;
		this.currentAlignmentProperties = null;
	}

	get isOpen() {
		return this._isOpen;
	}

	destroy() {
		this.contentComponent && this.contentComponent.destroy();
		this.$dropDown.remove();
	}
}
